import { BorderProps, LayoutProps, PaddingProps, MarginProps, ColorProps, SpaceProps, TypographyProps } from 'styled-system';

export type GeneralInputStyleProps = {
  outline?: string;
} & BorderProps &
  LayoutProps &
  PaddingProps &
  MarginProps &
  ColorProps &
  SpaceProps &
  TypographyProps;

export const defaultInputStyleProps = {
  width: '100%',
  fontSize: 'inherit',
  fontFamily: 'inherit',
  mr: '8px',
  marginBottom: '4px',
  paddingY: '8px',
  paddingX: ['4px', '8px'],
  border: '#3c3c3b solid',
  borderWidth: '0px 0px 1px 0px',
  color: 'black',
};
